import { render, staticRenderFns } from "./AllGamesPar.vue?vue&type=template&id=68998582&scoped=true&"
import script from "./AllGamesPar.vue?vue&type=script&lang=js&"
export * from "./AllGamesPar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68998582",
  null
  
)

export default component.exports